import script from "./ChatMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessages.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessages.vue?vue&type=style&index=0&id=e16d4470&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e16d4470"]])

export default __exports__